/* eslint-disable no-shadow */
var LocationType;
(function (LocationType) {
    LocationType["LEID"] = "LEID";
    LocationType["FRANCHISE"] = "FRANCHISE";
    LocationType["RE_RENTER"] = "RE_RENTER";
    LocationType["SAAS"] = "SAAS";
})(LocationType || (LocationType = {}));

export { LocationType };
//# sourceMappingURL=locationType.js.map
